import { PickerContainer } from "./Components";
import DatePicker from "react-multi-date-picker";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import { ErrorMessage, Field, getIn } from "formik";
import { Form } from "react-bootstrap";
import { FormErrorMessage, Required } from "../FormInput/Components";

export default function FormDatePicker({label, formik, isRequired, theme, ...props}){
    const { name } = props;
    const {touched, errors} = formik;
    
    return (
        <Form.Group className={"mb-3"}>
            <Field name={name}>
            {({ field }) => {
                const error = getIn(formik.errors, field.name);
                const touch = getIn(formik.touched, field.name);
                return (
                    <>
                        {label && <Form.Label>{label} {isRequired && <Required>*</Required>}</Form.Label>}
                        <PickerContainer className={(theme?"input-"+theme:"")}>
                            <DatePicker
                                {...props}
                                calendar={gregorian}
                                locale={gregorian_en}
                                digits={["0","1","2","3","4","5","6","7","8","9"]}
                                calendarPosition="bottom-right"
                                {...field}
                                inputClass={"form-control " + (touch && error?"is-invalid":"")}
                                editable={false}
                                onChange={(value) => {
                                    formik.setFieldValue(field.name, value.toDate());
                                }}
                            />
                        </PickerContainer>
                        {touch && error && <ErrorMessage name={field.name}>
                            {(msg) => <FormErrorMessage type="invalid">{msg}</FormErrorMessage>}
                        </ErrorMessage>}
                    </>
                )
            }}
            </Field>
        </Form.Group>
        // /.toDate().toISOString().split("T")[0]
    )
}